import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function AdminNews() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", summary: "", body: "", image_url: "", category: "annonce", published: true });
  const [error, setError] = useState("");

  const load = () => api.get("/news?limit=100").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/news", form);
      setForm({ title: "", summary: "", body: "", image_url: "", category: "annonce", published: true });
      load();
    } catch (err) { setError(formatApiError(err)); }
  };

  const del = async (id) => {
    if (!window.confirm("Supprimer cette actualité ?")) return;
    await api.delete(`/news/${id}`);
    load();
  };

  return (
    <div data-testid="admin-news">
      <div className="eyebrow eyebrow-dark">Éditorial</div>
      <h1 className="mt-2 text-3xl font-bold text-unisic-blue">Actualités</h1>
      <span className="divider-gold mt-3" />

      <form onSubmit={submit} className="mt-8 paper-card p-6 grid gap-4" data-testid="news-form">
        <input required placeholder="Titre" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="border border-slate-300 px-3 py-2.5 rounded-sm text-sm" data-testid="input-news-title" />
        <input required placeholder="Résumé court" value={form.summary} onChange={(e) => setForm({ ...form, summary: e.target.value })} className="border border-slate-300 px-3 py-2.5 rounded-sm text-sm" />
        <textarea required rows={5} placeholder="Contenu complet" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} className="border border-slate-300 px-3 py-2.5 rounded-sm text-sm" />
        <div className="grid md:grid-cols-2 gap-4">
          <input placeholder="URL image (facultatif)" value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} className="border border-slate-300 px-3 py-2.5 rounded-sm text-sm" />
          <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="border border-slate-300 px-3 py-2.5 rounded-sm text-sm bg-white">
            <option value="annonce">Annonce</option>
            <option value="recherche">Recherche</option>
            <option value="partenariat">Partenariat</option>
            <option value="evenement">Événement</option>
          </select>
        </div>
        {error && <div className="text-sm text-unisic-red">{error}</div>}
        <div className="flex justify-end">
          <button className="btn-primary text-sm" type="submit" data-testid="btn-add-news"><Plus className="w-4 h-4" /> Publier</button>
        </div>
      </form>

      <div className="mt-8 space-y-3">
        {items.map((n) => (
          <div key={n.id} className="paper-card p-4 flex justify-between items-center gap-4" data-testid={`news-row-${n.id}`}>
            <div className="flex items-center gap-4 min-w-0">
              {n.image_url && <img src={n.image_url} alt="" className="w-16 h-16 object-cover rounded-sm" />}
              <div className="min-w-0">
                <div className="text-[11px] uppercase tracking-widest text-unisic-gold">{n.category}</div>
                <div className="font-display font-semibold text-unisic-blue truncate">{n.title}</div>
                <div className="text-xs text-slate-500 truncate">{n.summary}</div>
              </div>
            </div>
            <button onClick={() => del(n.id)} className="text-slate-400 hover:text-unisic-red flex-shrink-0" data-testid={`btn-del-news-${n.id}`}>
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
